import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, effect, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import posthog from 'posthog-js';
import { GoalService } from '../../core/goal/goal.service';
import { PostHogEvent } from '../../core/posthog/posthog.event';
import { ResumeService } from '../../core/resume/resume.service';
import { NewEditGoalComponent } from '../../domain/goal/new-edit-goal/new-edit-goal.component';
import { NewInterviewCopilotComponent } from '../../domain/interview-copilot/new-interview-copilot/new-interview-copilot.component';
import { UploadResumeComponent } from '../../domain/resume/upload-resume/upload-resume.component';
import { InterviewSidebarComponent } from '../home/interview-sidebar/interview-sidebar.component';
import { LambdaService } from './../../shared/core/lambda.service';

@Component({
  selector: 'app-get-started',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    YouTubePlayerModule,

    NzStepsModule,
    NzButtonModule,
    NzIconModule,
    NzSkeletonModule,

    InterviewSidebarComponent,

    UploadResumeComponent,
    NewEditGoalComponent,
    NewInterviewCopilotComponent,
  ],
  templateUrl: './get-started.component.html',
  styleUrl: './get-started.component.scss',
})
export class GetStartedComponent {
  isNewEditGoalVisible = false;
  isNewResumeVisible = false;
  isNewInterviewVisible = false;

  videoList = [
    {
      id: 'DCx0qCor9HQ',
      title: '[Tutorial] How to set up 360Interview AI assistant in 3 steps?',
    },
    {
      id: 'd1W3g7cuXk0',
      title: '[Intro] How to ace normal interviews using the 360Interview AI assistant?',
    },
    {
      id: 'kYPCb8QCnlI',
      title: '[Intro] How to ace coding/technical interviews using the 360Interview AI assistant?',
    },
  ];

  currentIndex = -1;

  goalList = toSignal(this.goalService.goalList$(), { initialValue: [] });
  resumeList = toSignal(this.resumeService.resumeList$(), { initialValue: [] });

  isLoading = toSignal(this.lambdaService.isLoading$, { initialValue: true });

  isMobile = signal<boolean>(false);

  constructor(
    private router: Router,
    private goalService: GoalService,
    private resumeService: ResumeService,
    private lambdaService: LambdaService,
    private breakpointObserver: BreakpointObserver
  ) {
    effect(() => {
      const goalListLegnth = this.goalList().length;
      const resumeListLength = this.resumeList().length;

      if (goalListLegnth > 0) {
        if (resumeListLength > 0) {
          this.currentIndex = 2;
        } else {
          this.currentIndex = 1;
        }
      } else {
        this.currentIndex = 0;
      }
    });
  }

  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
      this.isMobile.set(result.matches);
    });
  }

  onTargetPositionListClick() {
    this.router.navigate(['/target-positions']);
  }

  onResumeListClick() {
    this.router.navigate(['/resume']);
  }

  onSetTargetPositionClick() {
    posthog.capture(PostHogEvent.positionAddGetStarted);
    this.isNewEditGoalVisible = true;
  }

  onUploadResumeClick() {
    posthog.capture(PostHogEvent.resumeAddGetStarted);
    this.isNewResumeVisible = true;
  }

  onLaunchCopilotClick() {
    posthog.capture(PostHogEvent.interviewAddGetStarted);
    this.isNewInterviewVisible = true;
  }
}
